import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export function isSupported() {
  return typeof window !== 'undefined' && window.isSecureContext === true && 'Notification' in window;
}
export function getPermission() {
  if (!isSupported()) return 'unsupported';
  return Notification.permission;
}
export function requestPermission() {
  return _requestPermission.apply(this, arguments);
}
function _requestPermission() {
  _requestPermission = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isSupported()) {
            _context.n = 1;
            break;
          }
          return _context.a(2, 'unsupported');
        case 1:
          if (!(Notification.permission === 'granted')) {
            _context.n = 2;
            break;
          }
          return _context.a(2, 'granted');
        case 2:
          return _context.a(2, Notification.requestPermission());
      }
    }, _callee);
  }));
  return _requestPermission.apply(this, arguments);
}
export function show(title, body) {
  var icon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!isSupported()) return null;
  if (Notification.permission !== 'granted') return null;
  return new Notification(title, {
    body: body,
    icon: icon || undefined
  });
}
export default {
  isSupported: isSupported,
  getPermission: getPermission,
  requestPermission: requestPermission,
  show: show
};